import State from '../interfaces/states/State';

import { createSelector } from 'reselect';

const getUserCountry = createSelector(
  (state: State) => state.findUser.userInfo,
  (userInfo): string => {
    // @ts-ignore
    if (userInfo.data) {
      // @ts-ignore
      return userInfo.data[0].country;
    } else {
      return null;
    }
  }
);

export default getUserCountry;
